const MarkerCommon = require('od-modules/helpers/map/marker/marker_common');
const MARKER_OPTIONS = {
    cssClass: {
        base: 'custom_marker od-custom-marker',
        markerPin: 'od-custom-marker-pin',
        circle: 'od-custom-marker-circle',
        starPin: 'odf-icon odf-icon-star od-custom-marker-star',
    },
};
const SELECTED_MARKER_OPTIONS = {
    infoWindowOptions: {
        offset: {
            posX: -2,
            posY: 28,
        },
    },
};

function setSelectedIcon() {
    this.setOffset(true);
    this.setClass(this.options.cssClass.markerPin);
    this.setInfoWindowsOptions(SELECTED_MARKER_OPTIONS);
}

function setUnselectedIcon() {
    this.setOffset(false);
    this.setClass(this.options.cssClass.circle);
}
module.exports = function(libMap) {
    function Marker() {
        MarkerCommon.apply(this, arguments);
        this.setOptions(MARKER_OPTIONS);
    }

    Marker.prototype = new libMap.OverlayView();

    Odigeo._.extend(Marker.prototype, MarkerCommon.prototype, {
        constructor: Marker,

        render() {
            this.setIcon(this.getStatus());
        },

        setIcon(status) {
            if (status.isSelected) {
                setSelectedIcon.call(this);
            } else {
                setUnselectedIcon.call(this);
            }
        },
    });

    return Marker;
};
